// // src/redux/LoginSlice.js
// import { createSlice } from '@reduxjs/toolkit';

// const LoginSlice = createSlice({
//   name: 'user',
//   initialState: {
//     username: 'Guest',
//   },
//   reducers: {
//     setUsername: (state, action) => {
//       state.username = action.payload;
//     },

//     logout: (state) => {
//       state.username = 'Guest';
//     },
//   },
// });

// export const { setUsername,logout } = LoginSlice.actions;

// export default LoginSlice.reducer;


// import { createSlice } from '@reduxjs/toolkit';

// const LoginSlice = createSlice({
//   name: 'user',
//   initialState: {
//     username: 'Guest',
//   },
//   reducers: {
//     setUsername: (state, action) => {
//       state.username = action.payload; // Update username
//     },
//     logout: (state) => {
//       state.username = 'Guest'; // Reset to default on logout
//     },
//   },
// });

// export const { setUsername, logout } = LoginSlice.actions;

// export default LoginSlice.reducer;


import { createSlice } from '@reduxjs/toolkit';

const LoginSlice = createSlice({
  name: 'user',
  initialState: {
    username: 'Guest', // Default username
  },
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload; // Update username
    },
    logout: (state) => {
      state.username = 'Guest'; // Reset username on logout
    },
  },
});

export const { setUsername, logout } = LoginSlice.actions;

export default LoginSlice.reducer;
